import enviro from 'enviro';
const HAS_HERO_VIDEO = false;

// TODO: Replace with onboarding video values
const QA_HERO_VIDEO = {
  creatorHubId: 882999426,
  videoId: '199658635531'
};
const PROD_HERO_VIDEO = {
  creatorHubId: 882999426,
  videoId: '199658635531'
};
export const getHeroVideo = () => Object.assign({
  hasVideo: HAS_HERO_VIDEO
}, enviro.isQa() ? QA_HERO_VIDEO : PROD_HERO_VIDEO);